import asyncThunk from '@/lib/asyncThunk'
import { CustomerLookup } from '@/out/customer-lookup'

type Request = Record<never, never>

export const retrieveCustomerLookup = asyncThunk<Request, CustomerLookup>({
  name: 'customer-lookup/retrieve',
  uri: '/customer-lookup',
})
